import { OrderType } from '@coworkrz/core/types';
import { BOOLEAN_ENUM } from '@coworkrz/core/constants';

interface ToNumberOptions {
  default?: number;
  min?: number;
  max?: number;
}
interface ToBooleanOptions {
  default?: boolean;
}

export class CastHelper {
  static toLowerCase(value?: string): string | undefined {
    if (!value) return;
    return value?.toLowerCase();
  }

  static trim(value?: string): string | undefined {
    if (!value) return;
    return value?.trim();
  }

  static toDate(value?: string): Date | undefined {
    if (!value) return;
    return new Date(value);
  }

  static toBoolean(
    value?: BOOLEAN_ENUM,
    opts: ToBooleanOptions = {}
  ): boolean | undefined {
    if (typeof value === 'undefined' && typeof opts.default === 'boolean')
      return opts.default;

    if (!value || (value && !value.trim())) return;

    value = value.trim().toLowerCase() as BOOLEAN_ENUM;

    return Object.values(BOOLEAN_ENUM).includes(value)
      ? [BOOLEAN_ENUM.ONE, BOOLEAN_ENUM.TRUE].includes(value)
      : undefined;
  }

  static toNumber(
    value?: string,
    opts: ToNumberOptions = {}
  ): number | undefined {
    let newValue: number | undefined = undefined;

    if (!value) {
      if (typeof opts.default === 'number') newValue = opts.default;
      else return;
    }

    if (typeof newValue === 'undefined') newValue = +(value as string);

    if (opts.min && newValue < opts.min) newValue = opts.min;

    if (opts.max && newValue > opts.max) newValue = opts.max;

    return newValue;
  }

  static toOrder(value?: string): OrderType | undefined {
    if (!value) return;

    value = value.trim().toUpperCase();

    return ['ASC', 'DESC'].includes(value) ? (value as OrderType) : undefined;
  }

  static toArray<P>(value?: string): P[] | undefined {
    value = CastHelper.trim(value);
    if (!value) return;

    return value.split(',') as P[];
  }
}
